  class viewedProductList extends HTMLElement {
    constructor() {
      super();

      this.renderLimit = 10;
      this.ignoreProductHandle = this.getAttribute('data-ignore-handle') || "";
      this.sectionId = "async-product-card";

      if (this.hasAttribute('data-item-section')) {
        this.sectionId = this.getAttribute('data-item-section');
      }
      

      if (this.hasAttribute('data-limit')) {
        this.renderLimit = parseInt(this.getAttribute('data-limit'));
      };

      this.slots = this.querySelectorAll('viewed-product');
      this.viewedProducts = WDN__viewedProducts;
    }

    removeSelf() {
      if (this.closest("[data-hidden-if-empty]")) {
        this.closest("[data-hidden-if-empty]").remove();
      }
    }

    readViewedHistory() {
      this.viewedProductsList = this.viewedProducts.list();

      if (this.ignoreProductHandle.length > 0) {
        var foundIndex = this.viewedProductsList.indexOf(this.ignoreProductHandle);
        if (foundIndex > -1) {
          this.viewedProductsList.splice(foundIndex, 1);
        }
      }
    }

    sanitiseSlots() {
      if (this.viewedProductsList.length <= 1) {
        this.removeSelf();
      }

      if (this.slots.length > this.renderLimit) {
        this.slots.forEach((elem, index) => {
          if (index >= this.renderLimit) {
            elem.remove();
          }
        });
      }

      if (this.slots.length > this.viewedProductsList.length) {
        this.slots.forEach((elem, index) => {
          if (index >= this.viewedProductsList.length) {
            elem.remove();
          }
        });
      }

      this.viewedProductsList.length = this.slots.length;
    }

    registerWhenInView() {
      this.loadItems();
    }

    loadItems() {
      if (this.isLoaded == true) {
        return;
      }

      this.isLoaded = true;

      this.viewedProductsList.forEach((handle, index) => {
        this.slots[index].loadItem(handle, this.sectionId);
      });
    }

    connectedCallback() {
      this.readViewedHistory();
      this.sanitiseSlots();
      this.registerWhenInView();
    }
  }


  class viewedProductItem extends HTMLElement {
    constructor() {
      super();
        this.domParser = new DOMParser();
      }

      renderItem() {
        this.productCardHTML = this.domParser.parseFromString(this.productItemRes, "text/html").getElementById(this.sectionId);
        if (this.productCardHTML.getAttribute('data-product-id').length > 0) {
          this.innerHTML = this.productCardHTML.innerHTML;
        } else {
          WDN__viewedProducts.untrack(this.productHandle);
          this.parentNode.remove();
        }
      }

    fetchSection() {
        fetch(window.Shopify.routes.root + 'products/' + this.productHandle + "?section_id=" + this.sectionId, {
          headers: {
            'Content-Type': 'application/json'
          },
        })
        .then(response => {
          if (response.ok) {
            return response.text();
          }
          
          throw new Error('Something went wrong');
        })
        .then(responseText => {
          this.productItemRes = responseText;
          this.renderItem();
        }).catch((error) => {
          this.remove();
        });
      }

    loadItem(handle, sectionId) {
      this.setAttribute('data-product-handle', handle);

      this.productHandle = handle;
      this.sectionId = sectionId;
      this.fetchSection();
    }
  }

  customElements.define('viewed-product', viewedProductItem);
  customElements.define('viewed-productlist', viewedProductList);